import { Component } from 'preact'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
// eslint-disable-next-line import/no-internal-modules
import { isChangeEvent } from '@insided/deprecated-libs/typeGuards'

export interface SegmentDescriptionProps {
  title: string
  description: string
  onDescriptionChanged: (newValue: string) => void
}

interface State {
  isEditingDescription: boolean
}

class SegmentDescription extends Component<SegmentDescriptionProps, State> {
  textInputRef?: HTMLElement

  constructor(props: SegmentDescriptionProps) {
    super(props)

    this.state = {
      isEditingDescription: false
    }
  }

  componentDidMount() {
    document.addEventListener('mousedown', (e: MouseEvent) => this.onClickOutsideOfTextInput(e))
    document.addEventListener('keypress', (e: KeyboardEvent) => this.onPressEnterInTitle(e))
  }

  onTextClicked = () => {
    this.setState({ isEditingDescription: true }, () => {
      this.textInputRef?.focus()
    })
  }

  onClickOutsideOfTextInput = (e: MouseEvent) => {
    if (!this.textInputRef?.contains(e.target as Node)) {
      this.deactivateInput()
    }
  }

  onPressEnterInTitle = (e: KeyboardEvent) => {
    if (this.textInputRef && e.key === 'Enter') {
      this.deactivateInput()
    }
  }

  deactivateInput = () => {
    this.textInputRef?.blur()
    this.setState({ isEditingDescription: false }, () => {
      this.textInputRef = undefined
    })
  }

  render() {
    const { title, description } = this.props
    const { isEditingDescription } = this.state

    return (
      <div className='metric-summary-wrapper'>
        <div className='metric-summary metric-description'>
          <div className='metric-header'>
            <div className='metric-title'>{title}
              <span className='metric-title-edit' onClick={this.onTextClicked}>
                <Icon size={16} icon='edit' color='#9599a2' />
              </span>
            </div>
          </div>
          {isEditingDescription ? (
            <textarea
              ref={textInput => {
                this.textInputRef = textInput
              }}
              onChange={(e) => {
                if (isChangeEvent(e)) {
                  this.props.onDescriptionChanged(e.target.value.trim())
                }
              }}
            >{description}</textarea>
          ) : (
            <p onClick={() => this.onTextClicked()}>{description}</p>
          )}
        </div>
      </div>
    )
  }
}

export default SegmentDescription
